module.exports = __webpack_public_path__ + "static/media/espace_parents.2fa87e2c.png";